import { css as _css } from "@emotion/react";
import { useCallback, useRef, useState } from 'react';
import { Callout } from './Callout';
import { useOnClickTempToggle } from './use-on-click-temp-toggle';

/**
 * @deprecated Use {@link HubTooltip} instead.
 */

/**
 * A wrapper around the Callout component that handles the basic use case where
 * you click on an element and show the callout until the mouse moves away from
 * the element.
 *
 * More complex use cases should use the constituent parts instead of adding
 * complexity to this hook.
 *
 * @deprecated Use {@link HubTooltip} instead.
 */
export function useCallout({
  text,
  position,
  horizontal,
  tooltip,
  maxWidth
}) {
  const calloutRef = useRef(null);
  const [showingCallout, setShowingCallout] = useState(false);
  const setShowViewCallout = useOnClickTempToggle({
    ref: calloutRef,
    callback: useCallback(() => setShowingCallout(true), []),
    offCallback: useCallback(() => setShowingCallout(false), [])
  });
  const callout = showingCallout ? <Callout targetRef={calloutRef} position={position} horizontal={horizontal} css={/*#__PURE__*/_css({
    maxWidth,
    // Undo the transform in global-styles.tsx
    // because this needs to display in front of portaled elements in Safari
    transform: 'translateZ(1000px)'
  }, process.env.NODE_ENV === "production" ? "" : ";label:callout;")} tooltip={tooltip}>
			{text}
		</Callout> : null;
  return {
    callout,
    setShowViewCallout
  };
}